import { ExpectedSavingsChart } from './ExpectedSavingsChart'
import { OngoingContactsChart } from './OngoingContractsChart'
import { OngoingRFPsChart } from './OngoingRFPs'
import {
  TAdditionalValuesWidget,
  TOngoingContractsResponce,
  TOngoingRFPResponce,
  TSavingsResponce
} from '../types'
import '../styles.scss'
import { TOngoingItem } from './types'
import { AdditionalValues } from '../AdditionalValues/AdditionalValuesBlock'
import { ExpectedSavingsByCategoryWidget } from '../ExpectedSavingsByCategory/ExpectedSavingsByCategoryWidget'
import { TExpectedSavingsByCategoryWidget } from '../ExpectedSavingsByCategory/types'
import { TOptionsWithValueLabelResponse } from '../../../constants/types'

type ChartsProps = {
  savings: TSavingsResponce
  ongoing: TOngoingItem | null
  expectedSavingsByCategory: TExpectedSavingsByCategoryWidget
  additionalValues: TAdditionalValuesWidget
  additionalValuesTypes: TOptionsWithValueLabelResponse[]
}

export const Charts = ({
  savings,
  ongoing,
  expectedSavingsByCategory,
  additionalValues,
  additionalValuesTypes
}: ChartsProps) => {
  return (
    <div className="charts">
      <ExpectedSavingsChart data={savings} />

      <div className="column gap-24 full-width">
        <div className="row gap-24">
          <OngoingContactsChart
            data={ongoing?.contract as TOngoingContractsResponce}
          />
          <OngoingRFPsChart data={ongoing?.rfp as TOngoingRFPResponce} />
        </div>
        <div className="row gap-24">
          <ExpectedSavingsByCategoryWidget data={expectedSavingsByCategory} />
          <AdditionalValues
            data={additionalValues}
            typesList={additionalValuesTypes}
          />
        </div>
      </div>
    </div>
  )
}
